import React, { useContext } from "react";

import UserContext from "../context/UserContext";

import { Link } from "react-router-dom";
import { Navbar, Nav, Container, Button } from "react-bootstrap";

import cart from "../assets/cart.svg";
import user from "../assets/user.svg";

import { useCart } from "react-use-cart";

import "./header.css";

function Header() {
  const { userData, setUserData } = useContext(UserContext);

  const { totalUniqueItems } = useCart();

  const logout = () => {
    setUserData({
      token: undefined,
      user: undefined,
    });
    localStorage.setItem("auth-token", "");
  };

  return (
    <div>
      {userData.user ? (
        <>
          <div>
            <Navbar collapseOnSelect expand="lg" className="NavBar" fixed="top">
              <Container>
                <Navbar.Brand href="/">
                  <h2>
                    <b> e-temp </b>
                  </h2>
                </Navbar.Brand>
                <Navbar.Brand className="Cart_Icon">
                  <div className="nav-item">
                    <div className="nav-item">
                      <Link to="/cart" className="nav-link_icon ">
                        <img src={cart} alt="cart" height="25px" width="25px" />
                        <span className="cart_span">{totalUniqueItems}</span>
                      </Link>
                    </div>
                  </div>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav className="me-auto"></Nav>
                  <Nav>
                    <li className="nav-item">
                      <Link to="/" className="nav-link  ">
                        Home
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/shop" className="nav-link  ">
                        Shop
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/about" className="nav-link  ">
                        About Us
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/faq" className="nav-link  ">
                        F.A.Q
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/contact" className="nav-link  ">
                        Contact
                      </Link>
                    </li>

                    <div className="dropdown" style={{ marginLeft: "15px" }}>
                      <div className="dropbtn">
                        <img src={user} alt="user" height="25px" width="25px" />
                      </div>
                      <div className="dropdown-content">
                        {/* <li className="nav-item">
                          <Link to="/SignIn" className="nav-link  ">
                            Sign In
                          </Link>
                        </li> */}
                        <li className="nav-item">
                          <Link to="/SignUp" className="nav-link  ">
                            Sign Up
                          </Link>
                        </li>
                      </div>
                    </div>

                    <li className="nav-item">
                      <Link to="/cart" className="nav-link_icon ">
                        <img src={cart} alt="cart" height="25px" width="25px" />
                        <span className="cart_span">{totalUniqueItems}</span>
                      </Link>
                    </li>

                    <Button
                      variant="danger"
                      onClick={logout}
                      style={{ marginLeft: "20px", marginTop: "5px" }}
                    >
                      Log Out
                    </Button>
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>
          </div>
        </>
      ) : (
        <>
          <div>
            <Navbar collapseOnSelect expand="lg" className="NavBar" fixed="top">
              <Container>
                <Navbar.Brand href="/">
                  <h2>
                    <b> e-temp </b>
                  </h2>
                </Navbar.Brand>
                <Navbar.Brand className="Cart_Icon">
                  <div className="nav-item">
                    <div className="nav-item">
                      <Link to="/cart" className="nav-link_icon ">
                        <img src={cart} alt="cart" height="25px" width="25px" />
                        <span className="cart_span">{totalUniqueItems}</span>
                      </Link>
                    </div>
                  </div>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav className="me-auto"></Nav>
                  <Nav>
                    <li className="nav-item">
                      <Link to="/" className="nav-link  ">
                        Home
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/shop" className="nav-link  ">
                        Shop
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/about" className="nav-link  ">
                        About Us
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/faq" className="nav-link  ">
                        F.A.Q
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/contact" className="nav-link  ">
                        Contact
                      </Link>
                    </li>
                    <div className="dropdown" style={{ marginLeft: "15px" }}>
                      <div className="dropbtn">
                        <img src={user} alt="user" height="25px" width="25px" />
                      </div>
                      <div className="dropdown-content">
                        <li className="nav-item">
                          <Link to="/SignIn" className="nav-link  ">
                            Sign In
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/SignUp" className="nav-link  ">
                            Sign Up
                          </Link>
                        </li>
                      </div>
                    </div>

                    <li className="nav-item">
                      <Link to="/cart" className="nav-link_icon ">
                        <img src={cart} alt="cart" height="25px" width="25px" />
                        <span className="cart_span">{totalUniqueItems}</span>
                      </Link>
                    </li>
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>
          </div>
        </>
      )}
    </div>
  );
}

export default Header;
